import {ExternalLinkIcon} from '@heroicons/react/outline';

import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Link} from '@/components';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';
import UserProfile from '@/screens/User/Details/UserProfile';
import type {AdminAfriexPerson} from '@/types';

type UserSummaryProp = {
  user: AdminAfriexPerson;
  extraRow?: React.ReactNode;
};

const UserSummary = ({user, extraRow}: UserSummaryProp) => {
  const redirectLink = `/users/${user.id}`;
  return (
    <div className="bg-white dark:bg-transparent rounded-lg w-full px-5 sm:px-5 py-5 sm:py-5">
      <div className="flex items-center gap-4 mb-3">
        <h2 className="font-semibold text-2xl mr-3">{user.name?.fullName}</h2>
        <Link
          to={redirectLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-cyan-700 mr-2 hover:underline"
        >
          View User Profile
        </Link>
        <PermissionsProvider
          permission={AfriexAdminPermission.UserTransactionRead}
        >
          <Link
            to={`/transactions/user/${user.id}/statement`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-sm text-cyan-700 gap-2"
          >
            <ExternalLinkIcon className="w-4 h-4" />
            View Statement
          </Link>
        </PermissionsProvider>
      </div>
      <UserProfile
        user={user}
        showUserID
        showReferredBy
        showSecurityEnabled
        showKYCStatus
        showLastLogin
        showViewTransactions
        showRewardPoints
        showInteracEmails
        showRegistrationIP
        showPhone
        showPhoneVerified
        showUserLogs
        showStripeUser
        showUserSession
      />

      {extraRow || ''}
    </div>
  );
};

export default UserSummary;
